export default {
  confirm: "تأكيد",
  adjustAgain: "ضبط مرة أخرى"
};
